import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import useCanManageWebhook from "shared/Webhook/access/useCanManageWebhook";
import { NamedWebhooksIntegration } from "types/generated";

import { showDeleteConfirmation } from "../../DeleteConfirmation";
import WebhookOptionDropdown from "../../OptionsDropdown";

const WebhooksTableDropdownCell = ({
  item: webhook,
  ...cellProps
}: TableSimpleCellProps<NamedWebhooksIntegration>) => {
  const hasManageAccess = useCanManageWebhook()(webhook);

  return (
    <TableSimpleCell {...cellProps}>
      <WebhookOptionDropdown
        id={webhook.id}
        hasManageAccess={hasManageAccess}
        dotSize="small"
        onDeleteClick={() => showDeleteConfirmation({ name: webhook.name, id: webhook.id })}
      />
    </TableSimpleCell>
  );
};

export default WebhooksTableDropdownCell;
